import { useRouter } from "next/router";

import Footer from "../footer/index";
import Header from "../header/index";

import styles from "./styles.module.scss";

export default ({ children }: { children: JSX.Element }) => {
  const router = useRouter();

  const headerBlackList = ["/exhibition/apply"];
  const footerBlackList = ["/exhibition/apply"];

  return (
    <div id="layout" className={styles.layout}>
      {
        !headerBlackList.includes(router.pathname) && <Header />
      }
      <main className={styles.main}>{children}</main>
      {
        !footerBlackList.includes(router.pathname) && <Footer />
      }
    </div>
  );
};
